import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import SummaryApi from '../common';

const CampaignModal = ({ toggleCampaignModal, setShowCampaignModal, user }) => {
    const navigate = useNavigate()
    const [campaignData, setCampaignData] = useState(null);
    const [apiFailed, setApiFailed] = useState(false);

    useEffect(() => {
        const fetchCampaign = async () => {
            try {
                // const response = await axios.get(`${SummaryApi?.campaignInfo?.url}`, {});
                // setCampaignData(response?.data?.campaign);
                // setApiFailed(false);
                setCampaignData({
                    title: "Cashback Leaderboard",
                    rewardValue: "250",
                });
                setApiFailed(true);
            } catch (error) {
                console.error("Failed to load campaign info", error);

                // Fallback dummy data
                setCampaignData({
                    title: "Cashback Leaderboard",
                    rewardValue: "250",
                });
                setApiFailed(true);
            }
        };
        fetchCampaign();
    }, []);

    return (
        <div className="absolute top-16 right-4 bg-white rounded-lg shadow-lg p-4 w-80 z-50">
            <div className="flex items-start justify-between">
                <div>
                    <h4 className="text-lg font-semibold text-orange-600">🏆 {campaignData?.title}</h4>
                    <p className="text-sm mt-1 text-gray-700">
                        Earn up to <strong>₹{campaignData?.rewardValue}</strong> cashback or gift rewards based on your rank!
                    </p>
                </div>
                <button className="text-gray-500" onClick={toggleCampaignModal}>✖</button>
            </div>

            <div className="mt-4">
                {user?.id ? (
                    <>
                        <p className="text-sm text-gray-600 mb-1">
                            Hello, <strong>{user.fullName}</strong>
                        </p>
                        <p className="text-sm text-green-600 mb-2">
                            🎁 You’re eligible for: <strong>₹{campaignData?.rewardValue}</strong> Cashback
                        </p>
                        {!apiFailed && (
                            <button
                                className="bg-orange-500 text-white px-4 py-1 rounded text-sm w-full"
                                onClick={() => {
                                    setShowCampaignModal(false);
                                    navigate("/reward/winner/preview");
                                }}
                            >
                                View Leaderboard
                            </button>
                        )}
                    </>
                ) : (
                    <>
                        <p className="text-sm text-gray-700 mb-2">
                            🔐 Login to view your rank and earn rewards!
                        </p>
                        <Link
                            to="/login"
                            className="bg-orange-500 text-white px-4 py-1 rounded text-sm w-full block text-center"
                            onClick={() => setShowCampaignModal(false)}
                        >
                            Login & View Campaign
                        </Link>
                    </>
                )}
            </div>
        </div>
    )
}

export default CampaignModal;
